import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StyledStat = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.palette.darkGrey};
  font-size: 13px;

  svg {
    font-size: 16px;
  }
`;

export const StatItem: FC<{ children: ReactNode }> = ({ children }) => {
  return <StyledStat>{children}</StyledStat>;
};
